import { USER_ROLE } from 'utils/constants';
import TAXONOMY_LINKS from './links';
import UpdateTaxonomy from './updateTaxonomy';
import TaxonomyListing from './index';
import HealthcareTaxonomyListing from './components/healthcareTaxonomyList';
import UpdateHealthcareTaxonomy from './updateTaxonomy/updateHealthcareTaxonomy';
import CommunityTaxonomyListing from './components/communityTaxonomyList';

const TAXONOMY_ROUTES = [
  // SMK
  {
    path: TAXONOMY_LINKS.SMK_TAXONOMY_LISTING,
    exact: true,
    component: TaxonomyListing,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: TAXONOMY_LINKS.ADD_SMK_TAXONOMY,
    exact: true,
    component: UpdateTaxonomy,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: TAXONOMY_LINKS.EDIT_SMK_TAXONOMY,
    exact: true,
    component: UpdateTaxonomy,
    role: [USER_ROLE.ADMIN],
  },

  // TPZ
  {
    path: TAXONOMY_LINKS.TPZ_TAXONOMY_LISTING,
    exact: true,
    component: TaxonomyListing,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: TAXONOMY_LINKS.ADD_TPZ_TAXONOMY,
    exact: true,
    component: UpdateTaxonomy,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: TAXONOMY_LINKS.EDIT_TPZ_TAXONOMY,
    exact: true,
    component: UpdateTaxonomy,
    role: [USER_ROLE.ADMIN],
  },
  // Mediwatcher
  {
    path: TAXONOMY_LINKS.MEDIWATCHER_TAXONOMY_LISTING,
    exact: true,
    component: TaxonomyListing,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: TAXONOMY_LINKS.ADD_MEDIWATCHER_TAXONOMY,
    exact: true,
    component: UpdateTaxonomy,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: TAXONOMY_LINKS.EDIT_MEDIWATCHER_TAXONOMY,
    exact: true,
    component: UpdateTaxonomy,
    role: [USER_ROLE.ADMIN],
  },

  // Healthcare
  {
    path: TAXONOMY_LINKS.HEALTHCARE_TAXONOMY_LISTING,
    exact: true,
    component: HealthcareTaxonomyListing,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: TAXONOMY_LINKS.ADD_HEALTHCARE_TAXONOMY,
    exact: true,
    component: UpdateHealthcareTaxonomy,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: TAXONOMY_LINKS.EDIT_HEALTHCARE_TAXONOMY,
    exact: true,
    component: UpdateHealthcareTaxonomy,
    role: [USER_ROLE.ADMIN],
  },

  // Community
  {
    path: TAXONOMY_LINKS.COMMUNITY_TAXONOMY_LISTING,
    exact: true,
    component: CommunityTaxonomyListing,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: TAXONOMY_LINKS.ADD_COMMUNITY_TAXONOMY,
    exact: true,
    component: UpdateTaxonomy,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: TAXONOMY_LINKS.EDIT_COMMUNITY_TAXONOMY,
    exact: true,
    component: UpdateTaxonomy,
    role: [USER_ROLE.ADMIN],
  },
];

export { TAXONOMY_ROUTES, TAXONOMY_LINKS };
